module.exports = __webpack_public_path__ + "img/female-placeholder.e947ac16.svg";